import { Grid, Typography, Box, Stack, Chip, Button } from "@mui/material";

import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/styles/common-styles.scss";
import { DataGridComponent } from "../components/common/DataGridComponent";
import { GridColDef } from "@mui/x-data-grid-pro";
import { useAudit } from "../hooks/useAudit";
import { useSnackbar } from "../hooks/useSnackbar";
import { formatDateTime } from "../constants/dateFormats";

import { AppState, useAppSelector } from "./../store";
import DynamicPageLayout from "../components/common/DynamicPageLayout";
import { IPageLayoutType } from "../types/pageLayoutTypes";
const defaultAuditDetailsContentJson: IPageLayoutType[] = [
  {
    title: "",
    chip: "",
    content: [
      {
        label: "Activity Time",
        value: "",
        size: {
          mediumScreen: 3,
          extraSmallScreen: 12,
        },
      },
      {
        label: "User Email",
        value: "",
        size: {
          mediumScreen: 3,
          extraSmallScreen: 12,
        },
      },
      {
        label: "Type",
        value: "",
        size: {
          mediumScreen: 3,
          extraSmallScreen: 12,
        },
      },
      {
        label: "ID",
        value: "",
        size: {
          mediumScreen: 3,
          extraSmallScreen: 12,
        },
      },
    ],
  },
];

const AuditTrailDetails: React.FunctionComponent<any> = () => {
  const auditActivity = useAppSelector(
    (state: AppState) => state.auditSlice.auditDetails
  );

  const [rowData, setRowData] = useState<any>([]);
  const [auditDetailsContentJson, setAuditDetailsContentJson] = useState<
    IPageLayoutType[]
  >(defaultAuditDetailsContentJson);
  const { handleError } = useSnackbar();
  const [rowsCount, setRowsCount] = useState<number>(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });

  const {
    getAuditDetails,
    auditDetailsData,
    auditDetailsIsLoading,
    auditDetailsIsError,
    auditDetailsError,
  } = useAudit();

  useEffect(() => {
    getAuditDetails({
      audit_activity: auditActivity?.audit_activity,
      activity_datetime: auditActivity?.activity_datetime,
      user_email: auditActivity?.created_by,
      module: auditActivity?.module,
    });
  }, []);

  useEffect(() => {
    if (
      auditDetailsData &&
      Array.isArray(auditDetailsData) &&
      auditDetailsData.length > 0
    ) {
      setRowsCount(auditDetailsData.length);
      setRowData([...auditDetailsData]);
    }
  }, [auditDetailsData]);

  useEffect(() => {
    if (auditDetailsIsError) {
      setRowData([]);
      setRowsCount(0);
      const error: any = auditDetailsError;
      handleError(error);
    }
  }, [auditDetailsIsError]);

  useEffect(() => {
    auditDetailsContentJson[0].content.map((item) => {
      switch (item.label) {
        case "Activity Time":
          item.value = formatDateTime(auditActivity.activity_datetime);
          break;
        case "User Email":
          item.value = auditActivity.created_by;
          break;
        case "Type":
          item.value = auditActivity.module;
          break;
        case "ID":
          item.value = auditActivity.entity_id;
          break;
      }
      return item;
    });
    setAuditDetailsContentJson(auditDetailsContentJson);
  }, [auditActivity]);
  const navigate = useNavigate();

  const columns: GridColDef[] = useMemo(
    () => [
      {
        field: "field_name",
        headerName: "Field Name",
        minWidth: 100,
        flex: 1,
      },
      {
        field: "old_data",
        headerName: "Old Data",
        minWidth: 100,
        flex: 1,
      },
      {
        field: "new_data",
        headerName: "New Data",
        minWidth: 100,
        flex: 1,
      },
      {
        field: "reason",
        headerName: "Reason",
        minWidth: 100,
        flex: 1,
      },
      {
        field: "comments",
        headerName: "Comment",
        minWidth: 100,
        flex: 1,
      },
    ],
    []
  );

  const createColumns: GridColDef[] = useMemo(
    () => [
      {
        field: "field_name",
        headerName: "Field Name",
        minWidth: 100,
        flex: 1,
      },
      {
        field: "new_data",
        headerName: "New Data",
        minWidth: 100,
        flex: 1,
      },
    ],
    []
  );

  return (
    <>
      <Box className="backBtnWrap">
        <Button
          startIcon={<ArrowBackIosNewRoundedIcon />}
          size="small"
          onClick={() => navigate("/audit")}
        >
          Back
        </Button>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs>
          <Stack direction="row" spacing={2} className="dFlex alignItemsCenter">
            <Typography variant="h4" gutterBottom>
              Audit Trail Details
            </Typography>
            <Box sx={{ mt: 5 }}>
              <Chip
                label={auditActivity?.audit_activity || ""}
                color="info"
                size="small"
                variant="outlined"
              />
            </Box>
          </Stack>
        </Grid>
      </Grid>

      <Box my={2}>
        <DynamicPageLayout
          pageContentJson={auditDetailsContentJson}
          data={{}}
        />
      </Box>
      <Box
        className="dataGridWrapBox"
        sx={{ width: "100%", height: "calc(100vh - 300px)" }}
      >
        <DataGridComponent
          columns={
            auditActivity?.audit_activity == "Create" ? createColumns : columns
          }
          rows={rowData ?? []}
          showQuickFilter
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          loading={auditDetailsIsLoading}
          rowsCount={rowsCount}
          disableRowSelectionOnClick
          disableColumnFilter
          exportFileName="Audit_Trail"
        />
      </Box>
    </>
  );
};

export default AuditTrailDetails;
